var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AddUserFeedbackCard',{on:{"feedback-added":function($event){return _vm.$emit('action-complete')}}})}
var staticRenderFns = []

export { render, staticRenderFns }